import {z} from 'zod';

import {financingRateSchema} from './financingRateSchema';

/**
 * Bulk-applied rates always overwrite the nominal rate and the APR together, so both interest
 * rates are required.
 */
export const bulkFinancingRatesFormSchema = z.object({
  nominalRate: financingRateSchema,
  apr: financingRateSchema,
});

export type BulkFinancingRatesFormValues = z.infer<typeof bulkFinancingRatesFormSchema>;
